export const environment = {
  production: false,
  envName: 'dev' as const,
  appVersion: '1.0.0-dev',
  rpsApiUrl: 'https://dev-rps.collectco.com',
  // rpsApiUrl: 'https://localhost:44365',
  logLevel: 'debug' as 'debug' | 'info' | 'warn' | 'error' | 'none',
};


